import { inject, Injectable } from '@angular/core';
import { ConfigurationService } from '../configuration/configuration.service';
import { Environment } from '../../../environments/environment.class';

@Injectable({
  providedIn: 'root',
})
export class UrlUtilService {
  private readonly environment = inject(Environment);
  private readonly configurationService = inject(ConfigurationService);
  constructor() {}

  getChangementCoordonneesMouvementUrl(endpoint: string): string {
    const baseUrlSICaad = this.environment.mock
      ? this.environment.mockDomaine
      : this.configurationService.getValueOrBlank(configuration.ConfigMeta.OEL_PAAS_API_URL);
    const paasApiCheminBase = `${this.configurationService.getValueOrBlank('paas-api-chemin-base')}`;
    return baseUrlSICaad + paasApiCheminBase + endpoint;
  }
}
